export default state => {
	if (state.claims) {
		return Object.values(state.claims).filter(claim => {
			return typeof claim.claimed_by === 'string' && claim.claimed_by !== state.user.walletAddress;
		});
	} else {
		return [];
	}
};
